"use strict";

var _interopRequireDefault = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
var _interopRequireWildcard = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireWildcard.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PhonePicker = void 0;
var _react = _interopRequireWildcard(require("react"));
var _phonePickerModule = _interopRequireDefault(require("./phone-picker.module.scss"));
var _reactPhoneInput = _interopRequireDefault(require("react-phone-input-2"));
var _reactResizeDetector = require("react-resize-detector");
require("react-phone-input-2/lib/high-res.css");
var _classnames = _interopRequireDefault(require("classnames"));
var _countries = require("../../../constants/countries/countries");
var _useTranslation2 = require("../../../hooks/useTranslation/useTranslation");
var _chevronDown = require("../../../assets/icons/chevron-down.svg");
var countries = _countries.COUNTRY_CODES.map(function (x) {
  return x.key.toLocaleLowerCase();
});
var PhonePicker = function PhonePicker(_ref) {
  var id = _ref.id,
    name = _ref.name,
    value = _ref.value,
    onChange = _ref.onChange,
    className = _ref.className,
    error = _ref.error,
    required = _ref.required,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    placeholder = _ref.placeholder,
    searchPlaceholder = _ref.searchPlaceholder,
    noCountriesText = _ref.noCountriesText,
    _ref$autoFocus = _ref.autoFocus,
    autoFocus = _ref$autoFocus === void 0 ? false : _ref$autoFocus,
    testId = _ref['data-testid'];
  var containerRef = (0, _react.useRef)(null);
  var _useResizeDetector = (0, _reactResizeDetector.useResizeDetector)({
      targetRef: containerRef
    }),
    width = _useResizeDetector.width;
  var _useTranslation = (0, _useTranslation2.useTranslation)(),
    t = _useTranslation.t;
  var handleOnChange = function handleOnChange(value, data) {
    var rawPhone = value.slice(data.dialCode.length);
    if (rawPhone === '') {
      return onChange({
        number: '',
        key: '',
        countryCode: ''
      });
    }
    onChange({
      number: rawPhone,
      key: data.countryCode.toLocaleUpperCase(),
      countryCode: data.dialCode
    });
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    "data-testid": 'phone-picker-container',
    className: (0, _classnames.default)(_phonePickerModule.default['phone-picker'], className),
    ref: containerRef
  }, /*#__PURE__*/_react.default.createElement(_reactPhoneInput.default, {
    country: 'gb',
    onlyCountries: countries,
    value: "".concat(value.countryCode).concat(value.number),
    onChange: handleOnChange,
    enableSearch: true,
    placeholder: placeholder || '',
    searchPlaceholder:
    // @ts-ignore
    searchPlaceholder || t('phonePicker.searchPlaceholder'),
    searchNotFound: noCountriesText || t('phonePicker.noCountriesText'),
    preferredCountries: ['gb', 'us'],
    disableSearchIcon: true,
    disabled: disabled,
    disableDropdown: disabled,
    inputProps: {
      id: id,
      'data-testid': testId || 'phone-picker',
      name: name,
      required: required,
      autoFocus: autoFocus
    },
    inputClass: error ? _phonePickerModule.default['phone-picker__input--error'] : undefined,
    dropdownStyle: {
      maxWidth: width,
      minWidth: width
    }
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: _phonePickerModule.default['phone-picker__chevron']
  }, /*#__PURE__*/_react.default.createElement(_chevronDown.ReactComponent, null)));
};
exports.PhonePicker = PhonePicker;